import React from 'react';
export function Pricing() {
  return <section className="mb-24" data-id="element-341">
      <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-semibold text-[#1B2951] mb-8 leading-tight font-['Playfair_Display']" data-id="element-342">
        Your Investment in Transformation
      </h2>
      <div className="grid md:grid-cols-2 gap-8" data-id="element-343">
        <div className="bg-white p-8 rounded-lg shadow-md border border-[#7F8C8D]/10 hover:shadow-lg transition-all duration-300" data-id="element-344">
          <h3 className="text-xl font-semibold text-[#1B2951] mb-6 font-['Poppins']" data-id="element-345">
            Alternative Options:
          </h3>
          <div className="space-y-4" data-id="element-346">
            <div className="flex items-center" data-id="element-347">
              <span className="text-[#E74C3C] mr-3" data-id="element-348">❌</span>
              <p className="text-[#2C3E50] font-['Inter']" data-id="element-349">
                Botox: ₹15,000-30,000 per session
              </p>
            </div>
            <div className="flex items-center" data-id="element-350">
              <span className="text-[#E74C3C] mr-3" data-id="element-351">❌</span>
              <p className="text-[#2C3E50] font-['Inter']" data-id="element-352">
                Skin boosters: ₹8,000 per vial
              </p>
            </div>
            <div className="flex items-center" data-id="element-353">
              <span className="text-[#E74C3C] mr-3" data-id="element-354">❌</span>
              <p className="text-[#2C3E50] font-['Inter']" data-id="element-355">
                Premium serums: ₹3,000-5,000/month
              </p>
            </div>
            <div className="flex items-center" data-id="element-356">
              <span className="text-[#E74C3C] mr-3" data-id="element-357">❌</span>
              <p className="text-[#2C3E50] font-['Inter']" data-id="element-358">
                Clinical facials: ₹5,000 per session
              </p>
            </div>
            <div className="flex items-center mt-6 p-3 bg-[#FFE5D9] rounded-lg" data-id="element-359">
              <span className="text-[#27AE60] mr-3" data-id="element-360">✅</span>
              <p className="text-[#1B2951] font-semibold font-['Poppins']" data-id="element-361">
                Setu Skin: Youthful with Ceramides: ₹1,649/month
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-br from-[#FFB88C] to-[#FFE5D9] p-8 rounded-lg shadow-md border border-[#FFB88C]/50 hover:shadow-lg transition-all duration-300 flex flex-col" data-id="element-362">
          <div className="relative mb-6" data-id="element-363">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qBg7KoDGqMcdtWELZrwubG/Skin_Youthful_2025_PDP_-_12.jpg" alt="Setu Skin: Youthful Collagen with Ceramosides" className="w-full h-auto rounded-lg shadow-md" data-id="element-364" />
            <div className="absolute top-4 right-4 bg-[#FF8E72] text-white px-3 py-1 rounded-full font-bold text-sm font-['Poppins'] rotate-6" data-id="element-365">
              PEACH MANGO FLAVOR
            </div>
          </div>
          <div className="mt-auto flex items-center justify-center bg-white/80 p-3 rounded-lg" data-id="element-366">
            <div className="w-10 h-10 bg-[#FFB88C] rounded-full flex items-center justify-center mr-3 shadow-sm" data-id="element-367">
              <span className="text-white font-bold" data-id="element-368">60</span>
            </div>
            <p className="text-[#1B2951] font-semibold font-['Poppins']" data-id="element-369">
              DAYS MONEY-BACK GUARANTEE
            </p>
          </div>
        </div>
      </div>
    </section>;
}